import { Container, YoutubeIcon } from 'components/atoms';
import { useFormikContext } from 'formik';
import { IFormikContextType } from 'hooks/useFormikField';
import { IChannelVideoForm } from 'services/channel/types/query';

const ChannelVideoPlayer = () => {
  const { values }: IFormikContextType<IChannelVideoForm> =
    useFormikContext<IChannelVideoForm>();
  return (
    <div className='w-full items-start'>
      <Container className='w-[800px]'>
        <Container.Header
          title={
            <>
              <YoutubeIcon /> YouTube player
            </>
          }
        />
        <Container.Content className='p-0 rounded-b-md overflow-hidden'>
          <iframe
            id='ytplayer'
            width='800'
            height='450'
            src={`https://www.youtube.com/embed/${values.externalVideoId}`}
          />
        </Container.Content>
      </Container>
    </div>
  );
};

export default ChannelVideoPlayer;
